import { useQuery } from "@apollo/client";
import { Contract } from "@ethersproject/contracts";
import { abis, addresses } from "@my-app/contracts";
import {
  shortenAddress,
  useCall,
  useContractFunction,
  useEthers,
} from "@usedapp/core";
import { Badge, Col } from "antd";
import React, { useState } from "react";
import { FaGraduationCap } from "react-icons/fa";
import { IoMdChatbubbles } from "react-icons/io";
import {
  ButtonSpan,
  ChatDiv,
  ChatTitle,
  DeadlineSpan,
  DeadlineSpanHeading,
  DocumentationDiv,
  DocumentationTitle,
  FunctionButton,
  IconDiv,
  ListButtonDiv,
  ListDiv,
  ListDivider,
  ListHeading,
  ListJob,
  ListSpan,
  ListSpanHeading,
  ListSubTitle,
  ListTitle,
  MainDiv,
} from "../../components";
import { CHAINS } from "../../constants";
import { GET_JOBS_INFO_LIST } from "../../graphql/subgraph";
import { useJobsInfo, useJobsParams } from "../../hooks";
import { parseJobData } from "../../utils";
import { biconomyInstance, setBiconomy } from "../../web3";
import JobDetail from "../JobDetail";

const ListJobs = () => {
  const { library, account, chainId } = useEthers();

  const [selectedJob, setSelectedJob] = useState(null);
  console.log("selectedJob: ", selectedJob);

  let contract = new Contract(addresses[chainId ? chainId: CHAINS.Mumbai.chainId].epochBase, abis.epochBase, library);
  const { loading, error, data: jobList } = useQuery(GET_JOBS_INFO_LIST);
  console.log("error: ", error);
  console.log("loading: ", loading);
  console.log("jobList: ", jobList);
  const { error: contractCallError, value: jobsLength } =
    useCall({
      contract,
      method: "jobCounter",
    }) ?? {};
  console.log("jobCounter: ", jobsLength);
  console.log("contractCallError: ", contractCallError);

  const { state: stateExecuteJob, send: sendExecuteJob } = useContractFunction(
    contract,
    "executeJob",
    {
      transactionName: "ExecuteJob",
    }
  );

  console.log("stateExecuteJob", stateExecuteJob);

  const { state: stateExpireJob, send: sendExpireJob } = useContractFunction(
    contract,
    "expireJob",
    {
      transactionName: "ExpireJob",
    }
  );
  console.log("stateExpireJob: ", stateExpireJob);

  const jobsInfo = useJobsInfo(jobsLength ? parseInt(jobsLength) : 0, chainId);
  console.log("jobsInfoasd: ", jobsInfo);
  const jobsParams = useJobsParams(jobsLength ? parseInt(jobsLength) : 0, chainId);
  console.log("jobsParams: ", jobsParams);

  const executeJob = async (jobId) => {
    if (account) {
      try {
        if (!biconomyInstance) {
          await setBiconomy();
        }

        const newProvider = await biconomyInstance.provider;
        console.log("newProvider: ", newProvider);
        const contract = new Contract(
          addresses[chainId ? chainId: CHAINS.Mumbai.chainId].epochBase,
          abis.epochBase,
          biconomyInstance.ethersProvider
        );
        console.log("contract: ", contract);

        let { data } = await contract.populateTransaction.executeJob(jobId);
        console.log("dataaaa", data);
        let txParams = {
          data: data,
          to: addresses[chainId ? chainId: CHAINS.Mumbai.chainId].epochBase,
          from: account,
          signatureType: "EIP712_SIGN",
        };
        console.log("txParams", txParams);
        const tx = await newProvider.send("eth_sendTransaction", [txParams]);
        console.log("tx", tx);

        biconomyInstance.on("txHashGenerated", (data) => {
          console.log(data);
        });
        biconomyInstance.on("txMined", (data) => {
          console.log(data);
        });
      } catch (error) {
        console.log("Execute Error", error);
      }
    }
  };

  const expireJob = async (jobId) => {
    await sendExpireJob(jobId);
  };

  // useEffect(() => {
  //   console.log(stateExecuteJob);
  // }, [stateExecuteJob]);

  // useEffect(() => {
  //   console.log(stateExpireJob);
  // }, [stateExpireJob]);

  return (
    <MainDiv>
      {/* <h2>List Jobs</h2> */}
      <Col>
        <ListHeading>
          Automate your smart contracts with Epoch Protocol
        </ListHeading>
        <IconDiv>
          <DocumentationDiv>
            <FaGraduationCap
              style={{ fontSize: "18px", marginTop: "0.15rem" }}
            />
            <DocumentationTitle>Documentation</DocumentationTitle>
          </DocumentationDiv>
          <ChatDiv>
            <IoMdChatbubbles
              style={{ fontSize: "18px", marginTop: "0.15rem" }}
            />
            <ChatTitle>Developer's Chat</ChatTitle>
          </ChatDiv>
        </IconDiv>

        <ListDiv>
          {jobList &&
          jobList?.jobInfoEventEntities.length > 0 &&
          jobsInfo &&
          jobsInfo?.length > 0
            ? jobList.jobInfoEventEntities.map((job, i) => {
                const jobId = parseInt(job.id);
                const currentJobInfo = jobsInfo[jobId - 1];
                const jobData = parseJobData(job, currentJobInfo);

                return (
                  <>
                    {jobData ? (
                      //   <Card
                      //     title={job.name}
                      //     extra={<a href="#">More</a>}
                      //     style={{ width: 600, marginTop: "1rem" }}
                      // >
                      <ListJob>
                        <div
                          onClick={() => {
                            console.log("CLicked");
                            setSelectedJob(jobData);
                          }}
                          style={{ display: "flex" }}
                        >
                          <ListTitle style={{ flexGrow: 1 }}>
                            {jobData.name}
                          </ListTitle>
                          <ListButtonDiv>
                            <FunctionButton
                            // onClick={() => {
                            //   executeJob(i);
                            // }}
                            >
                              <ButtonSpan style={{ fontSize: "12px" }}>
                                <Badge status="success" />
                                {jobData.runOnce
                                  ? "Not Reccurring"
                                  : "Reccurring"}
                              </ButtonSpan>
                            </FunctionButton>
                            <FunctionButton
                              style={{ marginLeft: "2rem" }}
                              // onClick={() => {
                              //   expireJob(i);
                              // }}
                            >
                              <ButtonSpan style={{ fontSize: "12px" }}>
                                <Badge status="success" />
                                {jobData.isExpired ? "Inactive" : "Active"}
                              </ButtonSpan>
                            </FunctionButton>
                          </ListButtonDiv>
                        </div>

                        <ListSubTitle>
                          <ListSpanHeading>Initiator: </ListSpanHeading>{" "}
                          <ListSpan>
                            {shortenAddress(jobData.initiatorAddress)}
                          </ListSpan>
                        </ListSubTitle>

                        <ListSubTitle>
                          <div style={{ flexGrow: 1, display: "flex" }}>
                            <ListSpanHeading>Destination: </ListSpanHeading>{" "}
                            <ListSpan>
                              {shortenAddress(jobData.executionContract)}
                            </ListSpan>
                          </div>
                          <DeadlineSpanHeading>Deadline:</DeadlineSpanHeading>{" "}
                          <DeadlineSpan>
                            {new Date(
                              jobData.nextExecutionDeadline.toNumber() * 1000
                            ).toLocaleString()}
                          </DeadlineSpan>
                        </ListSubTitle>

                        {/* <ListSubTitle>
                      <ListSpanHeading> Run Once:</ListSpanHeading>

                      <ListSpan>
                        {jobData.runOnce ? "Not Reccurring" : "Reccurring"}
                      </ListSpan>
                    </ListSubTitle> */}

                        {/* <p>Execution Data: {jobData.data}</p> */}
                        {/* <ListSubTitle>
                      <ListSpanHeading> Is Active:</ListSpanHeading>

                      <ListSpan>{jobData.isExpired ? "No" : "Yes"}</ListSpan>
                    </ListSubTitle> */}
                      </ListJob>
                    ) : // </Card>
                    null}
                    <ListDivider />
                  </>
                );
              })
            : null}
        </ListDiv>
      </Col>
      <Col>
        <JobDetail
          executeJob={executeJob}
          expireJob={expireJob}
          selectedJob={selectedJob}
        />
      </Col>
    </MainDiv>
  );
};

export default ListJobs;
